import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { CLIENTS } from "@/data/content";

// Logos that render visually small due to their aspect ratio get a larger cap.
const LARGE = new Set([]);

// A bit larger still.
const XLARGE = new Set([
  "Mazagon Dock Limited",
  "Mukand Steel",
  "John Cockerill",
  "Tenova Metals",
  "Primetals",
]);

// Largest tier — logos with heavy whitespace / wordmarks that need to read big.
const XXLARGE = new Set([
  "SAIL",
  "Goa Shipyard Ltd",
  "SMS Group",
]);

// Top tier — biggest of all.
const TOP = new Set([
  "Larsen & Toubro",
  "Tata Steel",
]);

function logoMaxHeight(name) {
  if (TOP.has(name)) return "124px";
  if (XXLARGE.has(name)) return "100px";
  if (XLARGE.has(name)) return "84px";
  if (LARGE.has(name)) return "68px";
  return "44px";
}

export default function ClientLogos({ testid = "client-logos" }) {
  return (
    <TooltipProvider delayDuration={100}>
      <div
        data-testid={testid}
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 border-t border-l border-border"
      >
        {CLIENTS.map((c) => (
          <Tooltip key={c.name}>
            <TooltipTrigger asChild>
              <div
                data-testid={`client-logo-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group flex items-center justify-center h-32 md:h-40 px-6 border-r border-b border-border hover:bg-secondary transition-colors"
              >
                <img
                  src={c.logo}
                  alt={c.name}
                  loading="lazy"
                  className="client-logo"
                  style={{ maxHeight: logoMaxHeight(c.name) }}
                />
              </div>
            </TooltipTrigger>
            <TooltipContent side="top" className="font-mono-tech text-[11px] uppercase tracking-wider">
              {c.name}
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}
